import { render, staticRenderFns } from "./CustomerDialogsTable.vue?vue&type=template&id=70527554&scoped=true&"
import script from "./CustomerDialogsTable.vue?vue&type=script&lang=js&"
export * from "./CustomerDialogsTable.vue?vue&type=script&lang=js&"
import style0 from "./CustomerDialogsTable.vue?vue&type=style&index=0&id=70527554&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70527554",
  null
  
)

export default component.exports